<template>
  <div>
    <TitlePage :title="$t('create')+' '+$t('customer')"></TitlePage>

    <v-layout wrap>

      <v-flex md12 class="d-flex">
        <v-chip color="primary" label small text-color="white">{{$t('genericInfo')}}</v-chip>
      </v-flex>

      <v-flex md5 class="pl-4 pr-4">
        <v-text-field :label="$t('name')" v-model="item.name" :rules="validation.textRules" :error-messages="errors.name"></v-text-field>
      </v-flex>

      <v-flex md5 class="pl-4 pr-4">
        <v-text-field :label="$t('surname')" v-model="item.surname" :rules="validation.textRules" :error-messages="errors.surname"></v-text-field>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4">
        <v-switch v-model="item.active" inset :label="$t('status')" dense hide-details></v-switch>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('email')" v-model="item.email"  :error-messages="errors.email" :rules="validation.email"></v-text-field>
      </v-flex>
      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('password')" v-model="item.password"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword" :error-messages="errors.password"
        ></v-text-field>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('phone')" v-model="item.phone"></v-text-field>
      </v-flex>

      <v-flex md12 class="pl-4 pr-4">
        <vuetify-google-autocomplete id="map" :placeholder="$t('addressComplete')" v-on:placechanged="setAddressData" v-model="item.address_complete">
        </vuetify-google-autocomplete>
      </v-flex>

      <v-flex md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">{{$t('financialInfo')}}</v-chip>
      </v-flex>

      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('company')" v-model="item.financial_info.company"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('address')" v-model="item.financial_info.address"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('city')" v-model="item.financial_info.city"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('province')" v-model="item.financial_info.province"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('postal_code')" v-model="item.financial_info.postal_code"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('country')" v-model="item.financial_info.country"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('vat_code')" v-model="item.financial_info.vat_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('fiscal_code')" v-model="item.financial_info.fiscal_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('sdi_code')" v-model="item.financial_info.sdi_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('pec_address')" v-model="item.financial_info.pec_address"></v-text-field>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="secondary" class="ml-auto" @click="save" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "CreateCustomer",
  components: {TitlePage},
  data() {
    return {
      showPassword:false,
      item: {
        name: '',
        surname: '',
        email: '',
        password: '',
        phone: '',
        address_complete: "",
        position:{
          type: "",
          coordinates:[]
        },
        financial_info: {
          company: "",
          address: "",
          city: "",
          province: "",
          postal_code: "",
          country: "",
          vat_code: "",
          fiscal_code: "",
          sdi_code: "",
          pec_address: ""
        },
        active: false,
        image: null,
        followed_sports:[],
        followed_center:[],
        facebook_login: null,
        google_login: null,
      },
      check: true,
      errors:{
        name: '',
        surname: '',
        email: '',
        password: ''
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ],
        email: [
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || this.$t('emailNotValid')
          }
        ],
      }
    };
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser':'user/getUser'
    }),
  },
  async created(){
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'storeItem': 'customers/store'
    }),
    async save(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }


      await this.setLoading(true);
      var result = await this.storeItem(this.item)
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('createSuccess')
        })

        await this.$router.push('/customers/')

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.item.name){
        this.check = false
        this.errors.name = this.$t('fillMandatory');
      }

      if(!this.item.surname){
        this.check = false
        this.errors.surname = this.$t('fillMandatory');
      }

      if(!this.item.email){
        this.check = false
        this.errors.email = this.$t('fillMandatory');
      }

      if(!this.item.password){
        this.check = false
        this.errors.password = this.$t('fillMandatory');
      }



    },

    setAddressData: function (addressData, placeResultData, id) {

      this.item.position.type = "Point"
      this.item.position.coordinates = [addressData.longitude, addressData.latitude]

      var country = placeResultData.address_components.filter((info) => {
        if(info.types.includes('country')){
          return info
        }
      })

      this.item.financial_info.address = addressData.name
      this.item.financial_info.city = addressData.locality
      this.item.financial_info.province = addressData.administrative_area_level_2
      this.item.financial_info.postal_code = addressData.postal_code
      this.item.financial_info.country = (country[0].short_name) ? country[0].short_name : addressData.country

    },

    async resetError(){
      this.errors = {
        name: '',
        surname: '',
        email: '',
        password: ''
      }
    },

  },
  mounted() {

  },
}
</script>

<style>
</style>